import { createTranslations } from '@npco/common-utils-translations'

export const translations = createTranslations({
  description:
    "We don't have enough data to show your total available balance. Transfer funds into your Account to track your balance below.",
})
